import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./FloatingToolbox.css";

export const FloatingToolboxItem = ({ icon, imgSrc, label, onClick, color, bg }) => {
  return (
    <div className="toolbox-item-wrapper">
      <button 
        className="toolbox-item" 
        onClick={onClick} 
        aria-label={label}
        style={{ backgroundColor: bg || "#1e293b", color: color || "#ffffff" }}
      >
        {imgSrc ? (
          <img src={imgSrc} alt={label} style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover' }} />
        ) : (
          <FontAwesomeIcon icon={icon} />
        )}
      </button>
      <span className="toolbox-tooltip">{label}</span>
    </div>
  );
};

const FloatingToolbox = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toolboxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      // Don't close if clicking inside the toolbox itself
      if (toolboxRef.current && !toolboxRef.current.contains(e.target)) {
        // Also don't close if they are interacting with the scratchpad popup
        if (!e.target.closest('.scratchpad-popup')) {
          setIsOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="floating-toolbox-container" ref={toolboxRef} dir="rtl">
      <div className={`toolbox-items ${isOpen ? "open" : ""}`}>
        {children}
      </div>
      <button
        className={`toolbox-main-btn ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="الأدوات"
      >
        <FontAwesomeIcon icon={isOpen ? faTimes : faTools} className="toolbox-icon" />
      </button>
    </div>
  );
};

export default FloatingToolbox;
